module.exports = "https://cdn-shared.mathletics.com/mathsaz/100/assets/images/d7991a738bee2093945808248299c046.svg";